export default {
  announcements: 'announcements',
  Token: 'Token',
  recentShops: 'recentShops',
  lastRoute: 'lastRoute',
}
